import React from "react"

import LoadingSpinner from "@fuse/sharedComponents/loader/LoadingSpinner"

import { useGlobalLoader } from "./GlobalLoaderContext"

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
}

const GlobalLoader: React.FC = () => {
  const { loading } = useGlobalLoader()
  if (!loading) return null
  return (
    <>
      <div style={overlayStyle}>
        <LoadingSpinner />
      </div>
    </>
  )
}

export default GlobalLoader
